import { render, staticRenderFns } from "./FunnelModal.vue?vue&type=template&id=71485f65"
import script from "./FunnelModal.vue?vue&type=script&lang=js"
export * from "./FunnelModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports